TS.ns('WL');

WL.partnerDashboardViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);
    },

    createCommands: function (config, server) {
        var me = this;
        me.parent(config);

        var cat = me.CommandCategories.Navigation.Commands();

        if (cat != null)
            for (var i = 0; i < cat.length; i++) {;
                if (cat[i].Code == "Reports") {
                    for (var j = 0; j < cat[i].Commands().length; j++) {
                        cat[i].Commands()[j].handler = "_showReport";
                    }
                }
            }
    },

    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.Reports.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            }); 
    }
});